var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.43962V3.85362C4.50002 3.75475 4.52936 3.6581 4.5843 3.57589C4.63924 3.49369 4.71732 3.42962 4.80867 3.39178C4.90002 3.35395 5.00054 3.34405 5.09751 3.36333C5.19449 3.38261 5.28357 3.43022 5.3535 3.50012L8.14649 6.29312C8.24023 6.38689 8.29289 6.51404 8.29289 6.64662C8.29289 6.77921 8.24023 6.90636 8.14649 7.00012L5.3535 9.79312C5.28357 9.86303 5.19449 9.91063 5.09751 9.92991C5.00054 9.9492 4.90002 9.9393 4.80867 9.90146C4.71732 9.86363 4.63924 9.79956 4.5843 9.71735C4.52936 9.63515 4.50002 9.5385 4.5 9.43962Z",
    fill: "#C2C6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumArrow);
export default __webpack_public_path__ + "static/media/breadcrum-arrow.4c5f24767a85b12c9026bcd58e7e992f.svg";
export { ForwardRef as ReactComponent };